import { Component, inject } from '@angular/core';
import { TaskModalService } from '../task-modal.service';
import { TaskBase } from 'src/api';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { DateV2Module } from '@schenck/rotec-components';

@Component({
  selector: 'ma-task-status',
  templateUrl: './task-status.component.html',
  styleUrls: ['./task-status.component.less'],
  imports: [TranslatePipe, TranslateDirective, AsyncPipe, DateV2Module],
})
export class TaskStatusComponent<Task extends TaskBase> {  taskModalService = inject<TaskModalService<Task>>(TaskModalService);

}
